import {
  AnnouncementsService,
  AnnouncementsServiceModule,
} from '@b2b/common/components/announcements/announcements.service';
import { parseUrl, ParseUrlFilterModule } from '@b2b/common/filters';
import { ApiService } from '@b2b/common/services/api/types';
import { AuthenticationService, AuthenticationServiceModule } from '@b2b/common/services/auth/authentication.service';
import { ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import { NavigationService, NavigationServiceModule } from '@b2b/common/services/navigation/navigation.service';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { TODO } from '@b2b/types/core/utils';
import { ACMEUserConfigResponse, UserData } from '@b2b/types/user';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';

function ApplicationController(
  $scope: IScope & { application: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  authenticationService: AuthenticationService,
  navigationService: NavigationService,
  sidebarService: SidebarService,
  contentHeaderService: TODO,
  helpersService: TODO,
  UserConfigData: { data: ACMEUserConfigResponse },
  userPreferencesService: TODO,
  ThemesData: TODO,
  themesHelperService: ThemesHelperService,
  apiService: ApiService,
  announcementsService: AnnouncementsService
) {
  const ctrl = {
    view: 'full',
    user: {},

    overlayStatus: '',

    overlayStatusStop: function (event) {
      $scope.$broadcast('OverlayStatus::stop');
    },

    init: function () {
      $scope.$on('Application::viewChange', ctrl.onApplicationViewChange);
      $scope.$on('Application::contentTitleChange', ctrl.onContentTitleChange);
      $scope.$on('Application::tenantSettingsUpdate', ctrl.onTenantSettingsUpdate);

      $scope.$on('Application::setOverlayStatus', function (e, status) {
        ctrl.overlayStatus = status;
      });

      $scope.$on('$locationChangeStart', function (event, next, prev) {
        if (/execution\/\d+/.test(prev)) {
          ctrl.overlayStatus = '';
        }
      });

      if (authenticationService.getUserFromCookie() != null) {
        // Main entry point of application should check if user has permissions
        // If a user is logged in but has no permissions we should log them out
        const userConfigData = UserConfigData.data?.success ? UserConfigData.data : null;
        const currentUser = userConfigData?.user ?? null;

        ctrl.checkPasswordStatus(currentUser);
        userPreferencesService.process(null, currentUser);

        if (ThemesData.data && ThemesData.data.success) {
          themesHelperService.resetModel();

          if (ThemesData && ThemesData.data.success) {
            ctrl.initThemes(ThemesData);
          }
        }
      } else {
        // User cookie has disappeared log user out
        $state.go('logout.default', {}, { notify: true });
      }
    },

    initThemes: function (response) {
      themesHelperService.setModel(response.data.payload);
      // Update main navigation
      $scope.$emit('Permissions::refresh');
    },

    checkPasswordStatus: function (currentUser: UserData | null) {
      if (authenticationService.isCSRImpersonating()) {
        return;
      }

      if (currentUser?.passwordStatus === 'EXPIRING_SOON') {
        const href = $state.href('application.account.profile', { changePassword: true });
        const userLink = parseUrl(href, 'Click here');

        announcementsService.addAnnouncement({
          type: 'warning',
          message: `Your password is about to expire! ${userLink} to change your password. ${currentUser.passwordDaysRemaining} days remaining.`,
        });
      }
    },

    isSidebarOpen: function () {
      return sidebarService.isShown;
    },

    onApplicationViewChange: function (e, data) {
      switch (data.view) {
        case 'full':
          ctrl.view = data.view;
          sidebarService.hide();
          break;
        default:
          ctrl.view = '';
      }
    },

    onContentTitleChange: function (e, data) {
      contentHeaderService.update(data);
    },

    onTenantSettingsUpdate: function (e, data) {
      apiService.themes.detail(true).then((response) => ctrl.initThemes(response));
    },
  };

  $scope.application = ctrl;
  ctrl.init();
}

ApplicationController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  'AuthenticationService',
  'NavigationService',
  'SidebarService',
  'ContentHeaderService',
  'HelpersService',
  'UserConfigData',
  'UserPreferencesService',
  'ThemesData',
  'ThemesHelperService',
  'ApiService',
  'AnnouncementsService',
];

export const ApplicationControllerModule = angular
  .module('acme.view.application.controllers', [
    uiRouter,
    'acme.common.service.auth',
    'acme.common.service.permissions',
    AuthenticationServiceModule,
    NavigationServiceModule,
    SidebarServiceModule,
    ContentHeaderServiceModule,
    'acme.common.service.userPreferences',
    'acme.common.service.themesHelper',
    'acme.common.service.api',
    AnnouncementsServiceModule,
    ParseUrlFilterModule,
  ])
  .controller('ApplicationController', ApplicationController).name;
